import { render, staticRenderFns } from "./no-file-image.generic.vue?vue&type=template&id=8c7bb4f4&"
import script from "./no-file-image.generic.vue?vue&type=script&lang=js&"
export * from "./no-file-image.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports